import type { AppLang } from "@/locale/appLang";
import { pickOfferSite } from "@/locale/content/offerSite";

export type SeoServicesNavLink = {
  href: string;
  label: string;
};

export type SeoServicesNavBundle = {
  sectionTitle: string;
  sectionSubtitle: string;
  navAriaLabel: string;
  links: SeoServicesNavLink[];
};

export function pickSeoServicesNav(lang: AppLang): SeoServicesNavBundle {
  const s = pickOfferSite(lang);
  return {
    sectionTitle: s.offersTitle,
    sectionSubtitle: s.hero.lead,
    navAriaLabel: s.nav.services,
    links: [
      { href: "/services/incident", label: s.services.incident.h1 },
      { href: "/services/audit", label: s.services.audit.h1 },
      { href: "/services/retainer", label: s.services.retainer.breadcrumb },
      { href: "/services/projects", label: s.services.projects.h1 },
      { href: "/cases", label: s.nav.cases },
      { href: "/about", label: s.nav.about },
      { href: "/contacts", label: s.nav.contacts },
    ],
  };
}
